module.exports = __webpack_public_path__ + "images/company_profile/icon_en02-ea258ded95b9c5d61ae796180f1417a8.png";